import { render, staticRenderFns } from "./sonService.vue?vue&type=template&id=3123c654&scoped=true&"
import script from "./sonService.vue?vue&type=script&lang=js&"
export * from "./sonService.vue?vue&type=script&lang=js&"
import style0 from "./sonService.vue?vue&type=style&index=0&id=3123c654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123c654",
  null
  
)

export default component.exports